import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertLevel, forHumans } from "@madmedical/medical";
import { Box, HStack, Text } from "native-base";
const RangeChart = ({ length, selectedIndex, alertLevel }) => {
    const getColor = () => {
        switch (alertLevel) {
            case AlertLevel.Ok:
                return "green.400";
            case AlertLevel.Warning:
                return "gray.600";
            case AlertLevel.Alert:
                return "error.400";
            default:
                return "gray.600";
        }
    };
    const getBG = () => {
        switch (alertLevel) {
            case AlertLevel.Ok:
                return "green.400";
            case AlertLevel.Warning:
                return "warning.400";
            case AlertLevel.Alert:
                return "error.400";
            default:
                return "gray.100";
        }
    };
    return (_jsx(HStack, Object.assign({ space: 0.5, width: "full", alignItems: "flex-end" }, { children: [...Array(length)].map((_, i) => (_jsxs(Box, Object.assign({ flex: 1 }, { children: [i === selectedIndex && (_jsx(Text, Object.assign({ color: getColor(), numberOfLines: 1, textAlign: "center", fontSize: "2xs", mb: 2 }, { children: forHumans(alertLevel) }))), _jsx(Box, { bg: i === selectedIndex ? getBG() : "gray.100", height: "3", borderLeftRadius: i === 0 ? "xs" : "none", borderRightRadius: i === length - 1 ? "xs" : "none" })] }), i))) })));
};
export default RangeChart;
